import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://f71ec9e127d88b57a4a54e35b113069f@o4510322145755136.ingest.de.sentry.io/4510322147655760",
  debug: false,
  environment: "prod",
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 0.1,
  integrations: [Sentry.browserTracingIntegration()],
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
});
import { init } from 'astro/virtual-modules/prefetch.js';init()